import React, { useState } from "react";
import { Typography, Container, Grid, TextField, Button } from "@mui/material";
import { getDatabase, ref, push, set ,child} from "firebase/database";
import { useNavigate } from "react-router-dom";

const SellerForm = () => {
  const navigate = useNavigate();

  const [formFields, setFormFields] = useState({
    ownerName: "",
    phoneNumber: "",
    location: "",
    pincode: "",
    shopName: "",
    shopPhoto: null,
    location:[],
  });

  const onChangeField = (e) => {
    const { name, value } = e.target;
    setFormFields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  const handleShopPhotoChange = (e) => {
    const file = e.target.files[0];
    setFormFields((prevFields) => ({
      ...prevFields,
      shopPhoto: file,
    }));
  };
  let postion=[]

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          postion=[latitude,longitude]
          //console.log("Current latitude:", latitude);
          //console.log("Current longitude:", longitude);
          
          // Optionally, you can set the latitude and longitude in the formFields state
          setFormFields((prevFields) => ({
            ...prevFields,
            latitude,
            longitude,
          }));
        },
        (error) => {
          console.error("Error getting current location:", error.message);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const database = getDatabase();
      const sellersRef = ref(database, "sellers");
      
      // Generate a unique key
      const uniqueKey = `${localStorage.getItem('user')}_details`;
      
      // Set the seller's details under the unique key
      await set(child(sellersRef, uniqueKey), {
        ownerName: formFields.ownerName,
        phoneNumber: formFields.phoneNumber,
        location: formFields.location,
        pincode: formFields.pincode,
        shopName: formFields.shopName,
        // Handle shop photo upload here
        shopPhoto: formFields.shopPhoto,
        coordinate: [] // Assuming location is defined somewhere in your code
      });
      
      console.log("Seller data sent to Firebase successfully!");

      // Redirect to '/addProduct' page
      navigate("/addProduct");
    } catch (error) {
      console.error("Error sending data to Firebase:", error.message);
    }
  };

  return (
    <Container style={{ marginTop: '90px', padding: '20px', marginBottom: '50px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" align="center" gutterBottom>
            Seller Registration Form
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Owner Name"
                  name="ownerName"
                  value={formFields.ownerName}
                  onChange={onChangeField}
                  color="success"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phoneNumber"
                  value={formFields.phoneNumber}
                  onChange={onChangeField}
                  color="success"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Location"
                  name="location"
                  value={formFields.location}
                  onChange={onChangeField}
                  color="success"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  value={formFields.pincode}
                  onChange={onChangeField}
                  color="success"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Shop Name"
                  name="shopName"
                  value={formFields.shopName}
                  onChange={onChangeField}
                  color="success"
                />
              </Grid>
              <Grid item xs={12}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleShopPhotoChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="success" // Change color to success
                  onClick={handleGetCurrentLocation}
                  fullWidth
                >
                  Get Current Location
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="success" // Change color to success
                  fullWidth
                >
                  Register
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SellerForm;
